<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='22'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <div class="cght_htmainrighttop">
            <div class="cght_shdtjxshd">
              <el-button type="primary" size="mini" round plain @click="showDialog()">添加供应商信息</el-button>
              <el-select v-model="listQuery.is_project" size="small" clearable placeholder="供应商类型" style="margin-left: 20px;margin-bottom:10px;margin-top: 10px;" @change="selectNewDate()">
                <el-option label="供应商" value="0"></el-option>
                <el-option label="项目商" value="1"></el-option>
              </el-select>
              <el-input size="small" v-model="listQuery.search" clearable placeholder="请输入商品名称" class="filter-item" style="width:350px;margin-bottom:10px;margin-top: 10px;">
                <el-button slot="append" @click="selectNewDate">搜索</el-button>
              </el-input>
              <el-select v-model="listQuery.user_id" placeholder="用户" clearable @change="selectNewDate()" size="small" style="margin-bottom:10px;margin-top: 10px;">
                <el-option
                  v-for="item in optionsUserList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="cght_subpagemaina" v-loading="qyloading">
            <!--右边内容区域开始-->
            <ul class="cght_shdzit">
              <li class="cght_shdzw1">公司名称</li>
              <li class="cght_shdzw1">纳税人识别号</li>
              <li class="cght_shdzw2">开户行信息</li>
              <li class="cght_shdzw3">经营产品</li>
              <li class="cght_shdzw3">供应商类型</li>
              <li class="cght_shdzw5">操作</li>
            </ul>
            <ul class="cght_shdzmain">
              <li class="cght_shdzwmrdzd" v-for="(item,index) in list" :key="index">
                <el-popover placement="top" trigger="hover">
                  <template>
                    <div v-if="item.company_name" class="set-popper">{{ item.company_name }}</div>
                  </template>
                  <div class="cght_shdzw1 set-content" slot="reference">{{item.company_name}}</div>
                </el-popover>
                <div class="cght_shdzw1">{{item.taxnum}}</div>
                <el-popover placement="top" trigger="hover">
                  <template>
                    <div style="width:300px" v-if="item.bank_account" class="set-popper">{{ item.bank_account }}</div>
                  </template>
                  <div class="cght_shdzw2 set-content" slot="reference">{{item.bank_account}}</div>
                </el-popover>
                <el-popover placement="top" trigger="hover" v-if="item.product">
                  <template>
                    <div style="width:300px" v-if="item.product" class="set-popper">{{ item.product }}</div>
                  </template>
                  <div class="cght_shdzw3 set-content" slot="reference">{{item.product}}</div>
                </el-popover>
                <div v-else class="cght_shdzw3" slot="reference"></div>
                <div class="cght_shdzw3">
                  <el-select v-model="item.is_project" placeholder="请选择" @change="changeproject(item, 'is_project')" size="mini" style="padding-top: 0px;padding-bottom: 0px;">
                    <el-option label="供应商" value="0"></el-option>
                    <el-option label="项目商" value="1"></el-option>
                  </el-select>
                </div>
                <div class="cght_shdzw5 cght_shdzw6" style="text-align: center;">
                  <div class="cght_shdzw5incs" style="float: none;width: auto;">
                    <a href="javascript:;" class="cght_shdttcxgxj" @click="showDialog(item)">修改</a>&emsp;
                    <a href="javascript:;" @click="delSupplier(item.id)">删除</a>
                  </div>
                </div>
              </li>
            </ul>
            <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
          </div>
          <el-dialog title="供应商信息" :visible.sync="dialogFormVisible">
            <el-form :model="dataForm" ref="dataForm" :rules="rules" label-position="left" label-width="110px" style="margin:0 20px 0 20px;">
              <el-form-item label="公司名称" prop="company_name" :error="errorMsgCompanyName">
                <el-input v-model="dataForm.company_name" @blur="checkRepeat($event, 1)" placeholder="请输入公司名称"></el-input>
              </el-form-item>
              <el-form-item label="经营产品">
                <el-input v-model="dataForm.product" placeholder="请输入经营产品"></el-input>
              </el-form-item>
              <el-form-item label="公司地址">
                <el-input v-model="dataForm.company_address" placeholder="请输入公司地址"></el-input>
              </el-form-item>
              <el-form-item label="公司链接">
                <el-input v-model="dataForm.company_url" placeholder="请输入公司链接"></el-input>
              </el-form-item>
              <el-form-item label="公司电话">
                <el-input v-model="dataForm.company_phone" placeholder="请输入公司电话"></el-input>
              </el-form-item>
              <el-form-item label="纳税人识别号" prop="taxnum" :error="errorMsgTaxnum">
                <el-input v-model="dataForm.taxnum" @blur="checkRepeat($event, 2)" placeholder="请输入纳税人识别号"></el-input>
              </el-form-item>
              <el-form-item label="开户行信息" prop="bank_account">
                <el-input type="textarea" rows="4" v-model="dataForm.bank_account" placeholder="例：中国光大银行股份有限公司XX分行-525201XXXXXXXXXXX
兴业银行XXXX分行-592010XXXXXXXXXXX
中信银行XXXX支行-8110701XXXXXXXXXX
"></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="linkman">
                <el-input v-model="dataForm.linkman" placeholder="请输入联系人"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="link_tel">
                <el-input v-model="dataForm.link_tel" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveSupplier">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import api from '@/api/supplier'
import busOrders from '@/api/businessOrders'
import VDistpicker from 'v-distpicker'
import { mapGetters } from 'vuex'
import Pagination from '@/components/Pagination'
import vuelist from '@/utils/vue_list'

export default {
  name: 'SupplierList',
  mixins: [vuelist],
  components: { Top, LeftNav, Bottom, VDistpicker, Pagination },
  data () {
    return {
      api,
      qyloading: false,
      dataForm: {
        id: null,
        company_name: '',
        company_address: '',
        company_url: '',
        company_phone: '',
        product: '',
        taxnum: '',
        bank_account: '',
        linkman: '',
        link_tel: '',
        user_id: null
      },
      listQuery: {
        limit: 10
      },
      dialogFormVisible: false,
      rules: {
        company_name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        taxnum: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
        bank_account: [{ required: true, message: '请输入供应商银行账户及开户行账号，如果有多个账户信息请“换行”填写', trigger: 'blur' }]
      },
      errorMsgCompanyName: '',
      errorMsgTaxnum: '',
      optionsUserList: []
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.LoadData()
    this.getUserList()
    // this.getSupplierList()
  },
  methods: {
    selectNewDate () {
      this.listQuery.page = 1
      this.LoadData()
    },
    delSupplier (id) {
      this.$confirm('此操作将删除该地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delSupplier({id: id}).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.LoadData()
        })
      }).catch(() => {})
    },
    showDialog (row) {
      if (!row) { row = {} }
      this.dialogFormVisible = true
      this.dataForm = Object.assign({}, row)
    },
    saveSupplier (row) {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.dataForm.user_id = this.current_user.id
          api.saveSupplier(this.dataForm).then((response) => {
            if (response.code === 20000) {
              this.dialogFormVisible = false
              this.$notify({
                title: '供应商信息',
                message: '提交成功',
                type: 'success'
              })
              this.LoadData()
            } else if (response.code === 10000) {
              this.$message({
                title: '供应商信息',
                message: response.message,
                type: 'error'
              })
            }
          })
        }
      })
    },
    changeproject (row, fieldName) {
      const params = { id: row.id }
      params[fieldName] = row[fieldName]
      api.changeproject(params).then(res => {
        if (res.code === 20000) {
          this.$message({ message: '操作成功', type: 'success' })
        } else {
          this.$message({ message: '操作失败', type: 'error' })
        }
      })
    },
    checkRepeat (event, e) {
      this.errorMsgCompanyName = ''
      this.errorMsgTaxnum = ''
      const params = { value: event.target.value, type: e }
      api.checkRepeat(params).then(res => {
        if (res.code === 20000) {
          if (res.type === 1) {
            this.errorMsgCompanyName = res.message
          } else if (res.type === 2) {
            this.errorMsgTaxnum = res.message
          }
        }
      })
    },
    getUserList () {
      busOrders.getUserList({MAccountRole: '1, 5'}).then(response => {
        this.optionsUserList = response.data
      })
    }
  }
}
</script>
<style scoped>
.cght_shdzwmrdzd div{
  line-height: 56px;
  padding: 2px 0px;
}
.cght_shdzw1{
  width: 190px;
}
.cght_shdzw2{
  width: 150px;
  text-align: center;
}
.cght_shdzw3{
  width: 100px;
  text-align: center;
  margin-left: 40px;
}
.cght_shdzw5{
  width: 100px;
}
.set-content{
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 文本溢出时显示省略号 */
  white-space: nowrap; /* 文本不换行 */
}
</style>



// WEBPACK FOOTER //
// src/view/member/supplier_list.vue